import { getEmployee, getEmployees, searchEmployees } from '@lib/api'
import { employeeKeys, employeesKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'
import { DateTime } from 'luxon'

interface Options {
  startDate: DateTime
  userId: number
  enabled?: boolean
}

export const useEmployee = (options: Options) => {
  return useQuery(
    employeeKeys.get(options.userId, options.startDate),
    () => getEmployee(options.userId, options.startDate),
    { enabled: options.enabled ?? true },
  )
}

export const useSearchEmployees = (start: DateTime, end: DateTime) => {
  return useQuery(employeeKeys.search(start, end), () =>
    searchEmployees(start, end),
  )
}

export const useEmployees = () => {
  return useQuery(employeesKeys.all, getEmployees)
}
